import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Chip,
    CircularProgress,
    Grid,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import ContactsIcon from '@mui/icons-material/Contacts';
import React, {useEffect, useState} from "react";
import {ContactData, DocumentDescriptor, DocumentFieldType} from "./DocumentData";
import {ePismoClientInstance} from "../Service/EPismoClient";
import {useKeycloak} from "@react-keycloak/web";
import {DatePicker, plPL} from "@mui/x-date-pickers";
import dayjs, {Dayjs} from "dayjs";
import CircleRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AttachmentsComponent from "./AttachmentsComponent";
import ContactGroupDialog from "./ContactGroupDialog";

type FileAttachment = {
    filename: string;
    content: string; // base64
}


export default function CreateDocumentStep2(props: { callback: any, documentTypeId: Number, initialReplyTo?: any }) {

    const [descriptor, setDescriptor] = useState<DocumentDescriptor>({'name': '', 'fields': [], attachmentsAllowed: false})
    const [contactData, setContactData] = useState<ContactData[]>([])
    const [data, setData] = useState<any>({})
    const [validationMessage, setValidationMessage] = useState("")
    const [contactDataQuery, setContactDataQuery] = useState("")
    const [selectedContacts, setSelectedContacts] = useState<ContactData[]>([]);
    const [showAllRecipients, setShowAllRecipients] = useState(false);
    const [loading, setLoading] = useState(false);
    const [attachments, setAttachments] = useState<FileAttachment[]>([]);
    const [contactGroupDialogOpen, setContactGroupDialogOpen] = useState(false);

    const keycloak = useKeycloak();

    useEffect(() => {
        if (props.initialReplyTo) {
            const replyTo = props.initialReplyTo;
            setSelectedContacts([{
                id: replyTo.senderId,
                name: replyTo.senderName,
                address: replyTo.senderAddress,
                activeInbox: true,
                filledEmail: true
            }]);
            setData({
                tytul: `Odpowiedź na pismo ${replyTo.documentNumber}`
            });
        }
    }, [props.initialReplyTo]);

    useEffect(() => {
        if (contactDataQuery && contactDataQuery.length > 2) {
            ePismoClientInstance.get("/v1/gui/documents/addresses?query=" + contactDataQuery + "&documentType=" + props.documentTypeId, keycloak).then(resp => {
                setContactData(resp.data)
            })
        }
    }, [contactDataQuery]);
    useEffect(() => {
        if (props.documentTypeId != null) {
            ePismoClientInstance.get("/v1/gui/documents/types/" + props.documentTypeId, keycloak).then(resp => setDescriptor(resp.data))
        }
    }, [props.documentTypeId]);

    const onChange = (field: string, e: any) => {
        setData((prev: any) => ({...prev, [field]: e}))
    }

    useEffect(() => {
        console.log(attachments)
    }, [attachments]);


    const send = () => {
        const recipientIds = selectedContacts.map(c => c.id);
        let document = ({...data, to: recipientIds})
        let invalidateFields = descriptor.fields
            .filter(f => f.required)
            .filter(f => (!(document as any)[f.key] || (document as any)[f.key] === 'Invalid Date'))
            .map(f => f.label);
        if (recipientIds.length === 0) {
            invalidateFields.push("Odbiorca")
        }
        if (invalidateFields.length > 0) {
            let message = 'Następujące pola są wymagane: ' + invalidateFields.join(', ')
            setValidationMessage(message)
        } else {
            setValidationMessage("")
            setLoading(true)
            let request = {
                documentType: props.documentTypeId,
                to: recipientIds,
                content: data,
                attachments: attachments
            }
            ePismoClientInstance.post("/v1/gui/documents", keycloak, request)
                .then(r => props.callback(r.data.documents))
                .catch(() => "Błąd podczas generowania dokumentu. Spróbuj ponownie później")
                .finally(() => setLoading(false))
        }
    }

    return (
        <Box className="Step2">
            <Grid container spacing={3}>
                <Grid xs={12}>
                    <Typography align="left" variant="h1"><span>2/3</span> Wypełnij formularz
                        - <span>{descriptor.name}</span></Typography>
                </Grid>
                <Grid xs={12}>
                    <Grid container>
                        <Grid item xs={11} >
                            <div className="autocomplete">
                                <Autocomplete
                                    multiple={true}
                                    value={selectedContacts}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    filterOptions={(x) => x}
                                    onInputChange={e => {
                                        setContactDataQuery((e.target as HTMLInputElement).value)

                                    }}

                                    onChange={(e, v) => setSelectedContacts(v || [])}
                                    renderTags={(value, getTagProps) => {
                                        const limit = 3;
                                        const numMore = value.length - limit;
                                        const shouldLimit = !showAllRecipients && numMore > 0;
                                        const itemsToShow = shouldLimit ? value.slice(0, limit) : value;

                                        return (
                                            <>
                                                {itemsToShow.map((option, index) => (
                                                    <Chip
                                                        label={option.name + " - " + option.address}
                                                        size="small"
                                                        {...getTagProps({ index })}
                                                    />
                                                ))}
                                                {shouldLimit && (
                                                    <Chip
                                                        label={`+${numMore} więcej... Pokaż wszystkich`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setShowAllRecipients(true);
                                                        }}
                                                        size="small"
                                                        clickable
                                                        sx={{ backgroundColor: 'transparent', border: '1px solid #bdbdbd' }}
                                                    />
                                                )}
                                                {showAllRecipients && value.length > limit && (
                                                    <Button
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setShowAllRecipients(false);
                                                        }}
                                                        sx={{textTransform: 'none', minWidth: 'auto', padding: '0 5px'}}
                                                    >
                                                        Pokaż mniej
                                                    </Button>
                                                )}
                                            </>
                                        );
                                    }}
                                    noOptionsText="Nie znaleziono"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            label="Odbiorca"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                            }}
                                        />)}
                                    getOptionLabel={o => o.name + " - " + o.address}
                                    renderOption={(props, data) => <li {...props}>
                                        <Grid container  columns={20}>
                                            <Grid item xs={2} md={1}>
                                                {data.activeInbox  && <VerifiedUserIcon fontSize="small" color="success"/>}
                                                {!data.activeInbox && data.filledEmail && <CircleRoundedIcon fontSize="small" color="success"/>}
                                                {!data.activeInbox && !data.filledEmail && <CircleRoundedIcon fontSize="small" color="warning"/>}
                                            </Grid>
                                            <Grid item xs={18} md={19}>
                                                <span>{data.name} </span>
                                                <Typography variant="body2" color="text.secondary" sx={{textAlign:"left"}}>{data.address}</Typography>
                                            </Grid>
                                        </Grid>
                                    </li>}
                                    options={contactData}/>
                            </div>
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton size="large" onClick={() => setContactGroupDialogOpen(true)}>
                                    <ContactsIcon/>
                                </IconButton>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} columns={11} container spacing={0} sx={{mt:0, mb:2}}>
                            <Grid item xs={12} sm={1} display="flex" alignItems="center" sx={{mt: 0, "paddingTop":0}}>
                            </Grid>
                            <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                <VerifiedUserIcon fontSize="small" color="success" sx={{mr: 1}}/>
                                <Typography variant="body2" color="text.secondary">Skrzynka odbiorcza</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                <CircleRoundedIcon fontSize="small" color="success" sx={{mr: 1}}/>
                                <Typography variant="body2" color="text.secondary">Znany adres e-mail</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                <CircleRoundedIcon fontSize="small" color="warning" sx={{mr: 1}}/>
                                <Typography variant="body2" color="text.secondary">Nieznany adres e-mail</Typography>
                            </Grid>
                        </Grid>

                        {descriptor.fields.map(f => {
                                return (<React.Fragment key={f.key}>
                                        {f.type === DocumentFieldType.TEXT &&
                                            <TextField size="small" fullWidth label={f.label} variant="outlined"
                                                       value={data[f.key] || ''}
                                                       onChange={e => onChange(f.key, e.target.value)}/>}
                                        {f.type === DocumentFieldType.TEXT_AREA &&
                                            <TextField multiline rows={8} maxRows={12} size="small" fullWidth label={f.label} variant="outlined"
                                                       value={data[f.key] || ''}
                                                       onChange={e => onChange(f.key, e.target.value)}/>}
                                        {f.type === DocumentFieldType.DATE && <DatePicker
                                            localeText={plPL.components.MuiLocalizationProvider.defaultProps.localeText}
                                            slotProps={{ textField: { size: 'small' } }}
                                            label={f.label}
                                            value={data[f.key] ? dayjs(data[f.key]) : null}
                                            onChange={e => onChange(f.key, e != null ? (e as Dayjs).format('YYYY-MM-DD') : null)}
                                            format="DD.MM.YYYY"/>}
                                        {f.type === DocumentFieldType.NUMBER &&
                                            <TextField size="small" type="number" fullWidth label={f.label}
                                                       value={data[f.key] || ''}
                                                       onChange={e => onChange(f.key, e.target.value)} variant="outlined"/>}
                                    </React.Fragment>
                                )
                            }
                        )}

                        {descriptor.attachmentsAllowed && (
                            <AttachmentsComponent
                                attachments={attachments}
                                onAttachmentsChange={setAttachments}
                                onError={setValidationMessage} />
                            )}

                            <Button size="large" fullWidth variant="contained" onClick={() => send()} disabled={loading}>
                                    {loading && <>Trwa generowanie pisma... <CircularProgress size={20} sx={{ml: 1}} /></>}
                                    {!loading && <>Nadaj pismo</>}
                                </Button>
                            {validationMessage && <Alert severity="error">{validationMessage}</Alert>}
                        </Grid>
                    </Grid>
                    <ContactGroupDialog
                        open={contactGroupDialogOpen}
                        onClose={() => setContactGroupDialogOpen(false)}
                        onConfirm={(contacts) => {
                            setSelectedContacts(prev => {
                                const map = new Map();
                                prev.forEach(c => map.set(c.id, c));
                                contacts.forEach(c => map.set(c.id, c));
                                return Array.from(map.values());
                            });
                        }}
                    />
                </Box>
            )
        }